import Loading from '../../components/Loading'
import * as React from 'react'
import { ReactElement, useEffect, useMemo } from 'react'
import FilePartyList, { FilePartyListProps } from '../../components/List/FileParty/FilePartyList'
import PartyConnectButton from '../../components/Form/PartyConnectButton'
import { makeStyles, MessageBar, tokens } from '@fluentui/react-components'
import { FilePartyRoleDto } from '../../context/GlobalContext'
import { useSettings } from '../../hooks/useSettings'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles({
    alert: {
        marginLeft: tokens.spacingHorizontalS,
        marginRight: tokens.spacingHorizontalS,
    },
})

export type FilePartyOverviewProps = Omit<FilePartyListProps, 'roles'>

export default function FilePartyOverview(props: FilePartyOverviewProps): ReactElement {
    const { settings } = useSettings()
    const location = useLocation<{ reload: boolean }>()
    const styles = useStyles()
    const { t: translate } = useTranslation()

    const roles: FilePartyRoleDto[] = useMemo(() => settings?.filePartyRoles, [settings])

    useEffect(() => {
        if (location?.state?.reload) {
            props.reset?.()
        }
    }, [location?.state?.reload])

    if (!roles || !props.data) {
        return <Loading />
    }

    return (
        <>
            {props.data.length === 0 ? (
                <MessageBar intent="info" className={styles.alert}>
                    {translate('file.pivot.party.list.empty')}
                </MessageBar>
            ) : (
                <FilePartyList {...props} />
            )}

            <PartyConnectButton
                iconProps={{ iconName: 'Add' }}
                fileId={props.file.id}
                roles={roles}
                translateFunction={translate}
                reset={props.reset}
            />
        </>
    )
}
